import Box from './Box/Box';
import PrismicLink from './PrismicLink/PrismicLink';
import { rem } from 'polished';
import { css } from 'styled-components';
import Lottie from 'lottie-react';
// @ts-ignore
import iAdamLogo from '../animations/iadam-logo.json';
// @ts-ignore
import iAdamLogoWithoutText from '../animations/iadam-logo-without-text.json';
import React from 'react';

export const AnimatediAdamButton = ({ link, onlyLogo }) => {
    return (
        <Box display="flex" alignItems="center">
            <PrismicLink link={link}>
                <Box
                    transition="all 200ms ease-out"
                    as="button"
                    cursor="pointer"
                    py={onlyLogo ? rem(4) : { _: rem(3), lg: rem(6) }}
                    px={rem(onlyLogo ? 4 : 15)}
                    borderRadius="sm"
                    _hover={{ backgroundColor: 'tertiary.purple.300' }}
                    css={css`
                        &:active {
                            transform: scale(0.96);
                            background-color: ${({ theme }) =>
                                theme.colors.tertiary.purple[500]};
                        }
                    `}
                >
                    <Box
                        width={rem(onlyLogo ? 32 : 98)}
                        height={rem(onlyLogo ? 32 : 33)}
                    >
                        <Lottie
                            animationData={
                                onlyLogo ? iAdamLogoWithoutText : iAdamLogo
                            }
                        />
                    </Box>
                </Box>
            </PrismicLink>
        </Box>
    );
};
